import React from 'react';
import { useSelector } from 'react-redux';
import Template from '../Components/Template';
import ConsolidatedReport from '../Components/ConsolidatedReport';

function ConsolidatedReportPage() {
  const userData = useSelector((state) => state.userData.user_data);
  const isAdmin = userData?.role === 'admin';

  return (
    <Template>
      <main id="main" className="main">
        <div className="container-fluid px-3">
          <ConsolidatedReport agentId={isAdmin ? undefined : userData?._id} />
        </div>
      </main>
    </Template>
  );
}

export default ConsolidatedReportPage;
